<template>
  <div class="integral-details" ref="container">
    <div class="header">
      艾灸师专业认证
      <router-link :to="{ path: '/user/AuthInfo' }" class="add-auth-info"
        >填写认证资料</router-link
      >
    </div>
    <div class="wrapper">
      <div class="nav acea-row">
        <div
          class="item acea-row row-center-wrapper"
          :class="current === index ? 'on' : ''"
          v-for="(item, index) in navList"
          :key="index"
          @click="nav(index)"
        >
          <span class="iconfont" :class="item.icon"></span>{{ item.name }}
        </div>
      </div>
      <div class="list">
        <div class="tip acea-row row-middle">
          <span class="iconfont icon-shuoming"></span
          >提示：请下单后在来完成艾灸师资料上传
        </div>
      </div>
    </div>
    <div class="goodList" v-if="current === 0">
      <router-link
        :to="{ path: '/detail/' + item.id }"
        class="item acea-row row-between-wrapper"
        v-for="(item, index) in list"
        :key="index"
      >
        <div class="pictrue">
          <img :src="item.img" class="image" />
          <img
            src="@assets/images/one.png"
            class="numPic"
            v-if="isSort === true && index === 0"
          />
          <img
            src="@assets/images/two.png"
            class="numPic"
            v-if="isSort === true && index === 1"
          />
          <img
            src="@assets/images/three.png"
            class="numPic"
            v-if="isSort === true && index === 2"
          />
        </div>
        <div class="underline">
          <div class="text">
            <div class="line1">{{ item.title }}</div>
            <div class="money font-color-red">
              ￥<span class="num">{{ item.price }}</span>
            </div>
            <div class="vip-money acea-row row-middle">
              <div class="vip" v-if="item.vip_price && item.vip_price > 0">
                ￥{{ item.vip_price || 0
                }}<img src="@assets/images/vip.png" class="image" />
              </div>
              <span class="num">已售{{ item.fsales }}{{ item.unit }}</span>
            </div>
          </div>
        </div>
        <div
          class="iconfont icon-gouwuche cart-color acea-row row-center-wrapper"
        ></div>
      </router-link>
    </div>
    <div class="my-order" v-else>
      <div class="list">
        <div class="item" v-for="order in orderList" :key="order.id">
          <div class="title acea-row row-between-wrapper">
            <div class="acea-row row-middle">
              {{ order.add_time }}
            </div>
            <div class="font-color-red">
              {{ order.status_msg || "订单状态" }}
            </div>
          </div>
          <div @click="$router.push({ path: '/order/detail/' + order.id })">
            <div
              class="item-info acea-row row-between row-top"
              v-for="(cart, index) in order.snapshot"
              :key="index"
            >
              <div class="pictrue">
                <img
                  :src="cart.productInfo.img"
                  @click.stop="
                    $router.push({ path: '/detail/' + cart.productInfo.id })
                  "
                  v-if="cart.productInfo.img"
                />
                <img
                  v-else
                  src="@assets/images/noGood.png"
                  @click.stop="
                    $router.push({ path: '/detail/' + cart.productInfo.id })
                  "
                />
              </div>
              <div class="text acea-row row-between">
                <div class="name line2">
                  {{ cart.productInfo.title || "" }}
                </div>
              </div>
            </div>
          </div>
          <div class="bottom acea-row row-right row-middle">
            <template
              v-if="
                order.status_code === 'PAY_SUCCESS' ||
                  order.status_code === 'SEND_OUT_GOODS'
              "
            >
              <div
                class="bnt bg-color-red"
                @click="$router.push({ path: '/order/detail/' + order.id })"
              >
                查看详情
              </div>
            </template>
            <template v-if="order.status_code === 'SEND_OUT_GOODS'">
              <div
                class="bnt default"
                @click="$router.push({ path: '/order/logistics/' + order.id })"
              >
                查看物流
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<style>
.add-auth-info {
  margin-top: 1rem;
  font-size: 0.3rem;
  border: 1px solid #ffffff;
  display: inline-flex;
  color: #ffffff;
  padding: 0.2rem 0.5rem;
  border-radius: 1rem;
}
</style>
<script>
import { authGetList, authOrder } from "@api/user";
import Loading from "@components/Loading";
export default {
  name: "UserAuth",
  components: {
    Loading
  },
  props: {},
  data() {
    return {
      navList: [
        { name: "专业认证", icon: "icon-mingxi" },
        { name: "我的认证", icon: "icon-tishengfenzhi" }
      ],
      imgUrls: [
        {
          img:
            "//aijiutang.oss-cn-beijing.aliyuncs.com/work_time/assets/images/bargainBg.jpg"
        }
      ],
      swiperNew: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      current: 0,
      where: {
        page: 1,
        page_size: 10
      },
      data: {
        sign: 1,
        integral: 1,
        all: 1
      },
      list: [],
      orderList: [],
      info: [],
      loaded: false,
      loading: false
    };
  },
  mounted() {
    this.getList();
    this.getOrder();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getList();
    });
  },
  methods: {
    nav(index) {
      this.current = index;
    },
    getOrder() {
      authOrder().then(r => {
        if (!r.data) {
          return;
        }
        this.orderList = r.data;
      });
    },
    getList() {
      if (this.loaded == true || this.loading == true) return;
      this.loading = true;
      authGetList({ ...this.where })
        .then(res => {
          res.data = res.data || [];
          if (this.where.page == 1) this.list = [];
          this.loaded = !res.data || res.data.length < this.where.page_size;
          this.where.page = this.where.page + 1;
          this.list.push.apply(this.list, res.data);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
